import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Content {
  id: string;
  name: string;
  type: string;
  fileUrl: string;
  thumbnailUrl: string | null;
  folderId: string | null;
  createdAt: string;
}

interface ContentState {
  items: Content[];
  selectedContent: Content | null;
  currentFolder: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: ContentState = {
  items: [],
  selectedContent: null,
  currentFolder: null,
  loading: false,
  error: null,
};

const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setContent: (state, action: PayloadAction<Content[]>) => {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    setSelectedContent: (state, action: PayloadAction<Content | null>) => {
      state.selectedContent = action.payload;
    },
    setCurrentFolder: (state, action: PayloadAction<string | null>) => {
      state.currentFolder = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    addContent: (state, action: PayloadAction<Content>) => {
      state.items.unshift(action.payload);
    },
    updateContent: (state, action: PayloadAction<Content>) => {
      const index = state.items.findIndex((c) => c.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    removeContent: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((c) => c.id !== action.payload);
    },
  },
});

export const {
  setContent,
  setSelectedContent,
  setCurrentFolder,
  setLoading,
  setError,
  addContent,
  updateContent,
  removeContent,
} = contentSlice.actions;

export default contentSlice.reducer;
